import {Component, forwardRef, Injector} from '@angular/core';
import {AppControlValueAccessorDirective} from '../AppControlValueAccessor';
import {FormControl, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-email-address-input',
  templateUrl: './email-address-input.component.html',
  styleUrls: ['./email-address-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailAddressInputComponent),
      multi: true,
    },
  ],
})
export class EmailAddressInputComponent extends AppControlValueAccessorDirective {
  emailFormControl = new FormControl('', {
    validators: [Validators.required, Validators.email],
    updateOn: 'change',
  });

  constructor(protected injector: Injector) {
    super();
    this.emailFormControl.valueChanges.pipe(takeUntil(this.onDestroy)).subscribe((newVal: string) => {
      if (this.emailFormControl.valid) {
        this.notifyOnChange(newVal);
      } else {
        this.notifyOnChange(undefined);
      }
    });
  }

  writeValue(obj: string): void {
    this.emailFormControl.setValue(obj);
  }
}
